module.exports = __webpack_public_path__ + "static/media/2to5.39ef9d14.svg";